var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$attrs.poems),function(poem){return _c('div',{key:poem.name,class:'poemContainer ' + poem.class},[_c('VueShowdown',{staticClass:"poem elevation-12",attrs:{"markdown":poem.markDown,"flavor":"github"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }